import axios from '@/api/axios'

export default {
    login({ email, password }) {
        return axios.post(`${process.env.VUE_APP_API_HOST}/api/login`, { email, password })
            .then(response => {
                return {
                    token: response.data.access_token,
                    email: response.data.user.email,
                    name: response.data.user.name,
                    role: response.data.user.role,
                    user_id: response.data.user.id,
                };
            })
            .catch(error => {
                throw error.response;
            });
    }
}
